var IndexController = function() {
    this.AdjustCard = require('../module/adjustCard');
    this.Popup = require('../module/Popup');

    this.init();
};

IndexController.prototype = {
    init: function() {
        var adjustCard = new this.AdjustCard();
        adjustCard.init();
        var popup = new this.Popup();
        popup.init();

        $(document).on('click', '.pickup-list a', function(e) {
            var $this = $(this);
            var index = $this.data('popup');
            //console.log(index);
            if (typeof index !== "undefined") {
                e.preventDefault();
                popup.open(index);
            }
        });
    }
};

module.exports = IndexController;


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/pc/assets/js/controller/IndexController.js
 **/